'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DynamicRenderer = require('acq-utils/lib/DynamicRenderer');

var _DynamicRenderer2 = _interopRequireDefault(_DynamicRenderer);

var _HeroBannerCardDetailsCorporate = require('../components/HeroBannerCardDetailsCorporate/HeroBannerCardDetailsCorporate');

var _HeroBannerCardDetailsCorporate2 = _interopRequireDefault(_HeroBannerCardDetailsCorporate);

var _HeroBannerCardDetailsBusiness = require('../components/HeroBannerCardDetailsBusiness/HeroBannerCardDetailsBusiness');

var _HeroBannerCardDetailsBusiness2 = _interopRequireDefault(_HeroBannerCardDetailsBusiness);

var _HeroBannerCardDetailsBusiness3 = require('../components/HeroBannerCardDetailsBusiness/variants/heroWithCardFeatures/HeroBannerCardDetailsBusiness');

var _HeroBannerCardDetailsBusiness4 = _interopRequireDefault(_HeroBannerCardDetailsBusiness3);

var _FeatureBreaker = require('../components/FeatureBreaker/FeatureBreaker');

var _FeatureBreaker2 = _interopRequireDefault(_FeatureBreaker);

var _ReinforcementBannerWrapper = require('../components/ReinforcementBannerWrapper/ReinforcementBannerWrapper');

var _ReinforcementBannerWrapper2 = _interopRequireDefault(_ReinforcementBannerWrapper);

var _SubNavWrapper = require('../components/SubNavWrapper/SubNavWrapper');

var _SubNavWrapper2 = _interopRequireDefault(_SubNavWrapper);

var _BenefitsWrapper = require('../components/BenefitsWrapper/BenefitsWrapper');

var _BenefitsWrapper2 = _interopRequireDefault(_BenefitsWrapper);

var _MarketingBannerWrapper = require('../components/RewardsBannerWrapper/variants/MarketingBannerWrapper');

var _MarketingBannerWrapper2 = _interopRequireDefault(_MarketingBannerWrapper);

var _AccordionWrapper = require('../components/AccordionWrapper/AccordionWrapper');

var _AccordionWrapper2 = _interopRequireDefault(_AccordionWrapper);

var _MiniCompareWrapper = require('../components/MiniCompareWrapper/MiniCompareWrapper');

var _MiniCompareWrapper2 = _interopRequireDefault(_MiniCompareWrapper);

var _StickyProductCTANav = require('../components/StickyProductCTANav/StickyProductCTANav');

var _StickyProductCTANav2 = _interopRequireDefault(_StickyProductCTANav);

var _TermsAndConditionsWrapperWithToggle = require('../components/TermsAndConditionsWrapperWithToggle/TermsAndConditionsWrapperWithToggle');

var _TermsAndConditionsWrapperWithToggle2 = _interopRequireDefault(_TermsAndConditionsWrapperWithToggle);

var _RumTelemetryScript = require('../components/RumTelemetryScript/RumTelemetryScript');

var _RumTelemetryScript2 = _interopRequireDefault(_RumTelemetryScript);

var _GoogleDisplayNetwork = require('../components/GoogleDisplayNetwork/GoogleDisplayNetwork');

var _GoogleDisplayNetwork2 = _interopRequireDefault(_GoogleDisplayNetwork);

var _pageMeta = require('acq-components/lib/utils/pageMeta');

var _PageContent = require('../components/PageContent/PageContent');

var _withPageSetup = require('../decorators/withPageSetup');

var _ImageBannerWrapper = require('../components/ImageBanner/ImageBannerWrapper');

var _ImageBannerWrapper2 = _interopRequireDefault(_ImageBannerWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrap = function wrap(Component) {
  return function (props) {
    return _react2.default.createElement(Component, props);
  };
};
var registry = {
  CardDetailsHeroBannerCorporate: wrap(_HeroBannerCardDetailsCorporate2.default),
  CardDetailsHeroBannerBusiness: wrap(_HeroBannerCardDetailsBusiness2.default),
  CardDetailsHeroBannerBusinessWithCardFeatures: wrap(_HeroBannerCardDetailsBusiness4.default),
  ReinforcementBannerWrapper: wrap(_ReinforcementBannerWrapper2.default),
  BenefitsWrapper: wrap(_BenefitsWrapper2.default),
  AccordionWrapper: wrap(_AccordionWrapper2.default),
  MiniCompareWrapper: wrap(_MiniCompareWrapper2.default),
  SubNavWrapper: wrap(_SubNavWrapper2.default),
  StickyProductCTANav: wrap(_StickyProductCTANav2.default),
  FeatureBreaker: wrap(_FeatureBreaker2.default),
  MarketingBannerWrapper: wrap(_MarketingBannerWrapper2.default),
  TermsAndConditionsWrapperWithToggle: wrap(_TermsAndConditionsWrapperWithToggle2.default),
  ImageBannerWrapper: wrap(_ImageBannerWrapper2.default)
};

var CardDetailsTemplate = function CardDetailsTemplate(_ref) {
  var _ref$pageStylesStr = _ref.pageStylesStr,
      pageStylesStr = _ref$pageStylesStr === undefined ? {} : _ref$pageStylesStr,
      _ref$stylesheet = _ref.stylesheet,
      stylesheet = _ref$stylesheet === undefined ? '' : _ref$stylesheet,
      _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$dataConfig = _ref.dataConfig,
      dataConfig = _ref$dataConfig === undefined ? function () {
    return {};
  } : _ref$dataConfig,
      _ref$seo = _ref.seo,
      seo = _ref$seo === undefined ? {} : _ref$seo,
      _ref$dtmHelper = _ref.dtmHelper,
      dtmHelper = _ref$dtmHelper === undefined ? {} : _ref$dtmHelper,
      shadeAlternator = _ref.shadeAlternator,
      order = _ref.order,
      _ref$shop = _ref.shop,
      shop = _ref$shop === undefined ? 'corporate' : _ref$shop,
      googleTag = _ref.googleTag;
  return _react2.default.createElement(
    'div',
    { className: shop + '-page-styles pdp-intl-page' },
    _react2.default.createElement(
      _pageMeta.PageMeta,
      seo,
      _react2.default.createElement(
        'style',
        null,
        '' + stylesheet + pageStylesStr
      )
    ),
    _react2.default.createElement(
      _PageContent.PageContent,
      null,
      _react2.default.createElement(_DynamicRenderer2.default, {
        registry: registry,
        dataConfig: dataConfig({ styles: styles, dtmHelper: dtmHelper, shadeAlternator: shadeAlternator }),
        order: order || []
      }),
      _react2.default.createElement(_RumTelemetryScript2.default, null),
      googleTag && _react2.default.createElement(_GoogleDisplayNetwork2.default, { dataConfig: dataConfig({}) })
    )
  );
};

exports.default = (0, _withPageSetup.withPageSetup)(CardDetailsTemplate);